module.exports = __webpack_public_path__ + "static/media/sateliteView.2ac754f7.svg";